// extracted by mini-css-extract-plugin
export var backLink = "privacy_policy-module--backLink--Itpxo";
export var backLink_wrap = "privacy_policy-module--backLink_wrap--0TcYa";
export var cellitem = "privacy_policy-module--cellitem--6Mlru";
export var grid = "privacy_policy-module--grid--Iazaa";
export var main_h1 = "privacy_policy-module--main_h1--pNWmS";
export var pageWrapper = "privacy_policy-module--pageWrapper--5-MwN";